export class TopUpEffect extends Phaser.GameObjects.Image {

    private end: { x: number, y: number }

    private spreadDistance: { min: number, max: number }

    constructor(scene: Phaser.Scene, frame: string, end: { x: number, y: number }, spreadDistance: { min: number, max: number }) {

        super(scene, 0, 0, "atlas", frame);

        this.visible = false;

        this.end = end;
        this.spreadDistance = spreadDistance;
    }

    public action(start: { x: number, y: number }) {
        this.setPosition(start.x + 20 - 50 * Math.random(), start.y + 20 - 80 * Math.random())
        this.alpha = 1;

        // First stage: spread
        const spreadDistance = Phaser.Math.Between(this.spreadDistance.min, this.spreadDistance.max);
        const spreadAngle = Phaser.Math.FloatBetween(-1.2, 1.2); // left or right
        const spreadX = start.x + Math.cos(spreadAngle) * spreadDistance;
        const spreadY = start.y + Math.sin(spreadAngle) * spreadDistance;

        this.setVisible(true)
        this.setScale(1)

        this.scene.tweens.chain({
            targets: this,
            tweens: [
                {
                    x: spreadX,
                    y: spreadY,
                    duration: 200,
                    ease: 'Sine.easeOut',
                },
                {
                    x: this.end.x,
                    y: this.end.y,
                    scale: 0.2,
                    alpha: 0,
                    duration: 500,
                    ease: 'Cubic.easeIn',
                    onComplete: () => {
                        window.Telegram.WebApp.HapticFeedback.selectionChanged();
                        this.visible = false;
                    },
                    delay: Math.random() * 300, // optional: stagger collection
                }
            ]
        });
    }
}
